import { FC, HTMLAttributes } from 'react';

type FarcasterProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const Farcaster: FC<FarcasterProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0241 19H1.10777V18.3032C1.10777 17.9826 1.34908 17.7226 1.64671 17.7226H1.75449V17.0258C1.75449 16.7051 1.99577 16.4452 2.29341 16.4452V6.10967H1.7006L1 3.55482H4.12575V1H15.8742V3.55482H19L18.2994 6.10967H17.7066V16.4452C18.0042 16.4452 18.2455 16.7051 18.2455 17.0258V17.7226H18.3533C18.6509 17.7226 18.8922 17.9826 18.8922 18.3032V19H12.9825V18.3032C12.9825 17.9826 13.2238 17.7226 13.5215 17.7226H13.6293V17.0258C13.6293 16.7118 13.8606 16.456 14.1497 16.4455V10.7548C13.9591 8.47607 12.1646 6.69031 10 6.69031C7.83536 6.69031 6.04092 8.47607 5.8503 10.7548V16.4453C6.14246 16.4521 6.37738 16.7094 6.37738 17.0258V17.3742V17.7226H6.48516C6.78279 17.7226 7.0241 17.9826 7.0241 18.3032V19Z"
        fill="#565960"
      />
    </svg>
  );
};

export default Farcaster;
